import { render, staticRenderFns } from "./CardPanicAlert.vue?vue&type=template&id=91aaae30"
import script from "./CardPanicAlert.vue?vue&type=script&lang=js"
export * from "./CardPanicAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports